import { RoleTitles } from "views/settings-users/slices/users/constants";
import { VerificationTemplateChangedActivity } from "../types";

export const VerificationTemplateChanged = ({
  activityItem
}: {
  activityItem: VerificationTemplateChangedActivity;
}) => {
  return (
    <div className="text-sm font-normal text-content-400">
      {activityItem.author?.name ? (
        <p>
          by {activityItem.author.name} (
          {activityItem.author.author_role
            ? RoleTitles[activityItem.author.author_role]
            : "--"}
          )
        </p>
      ) : null}
      <p>
        Default template: {activityItem.details.old_template_name} • Changed to:{" "}
        {activityItem.details.new_template_name}
      </p>
    </div>
  );
};
